<!-- header -->
<!-- header is parent of router-outlet and footer -->
<app-jsonld [json]="schema"></app-jsonld>
<router-outlet></router-outlet>
